import { useEffect, useState } from 'react'
import { ThemeProvider } from '@opallabs/hooks'
import { Button, Modal, WithTheme } from '@opallabs/lapidary'
import { TransformContent } from './TransformContent'

export type TransformContentModalProps = WithTheme & {
  isVisible: boolean
  onCloseModal: (changes?: { prompt: string }) => void
}
export type promptProps = {
  type: string
  prompt: string
}

export const TransformContentModal: React.FC<TransformContentModalProps> = ({
  isVisible,
  onCloseModal,
  theme = 'dark',
}) => {
  const [prompt, setPrompt] = useState<promptProps>({ type: '', prompt: '' })
  const [disabled, setDisabled] = useState<boolean>(true)
  const onClose = (closeArgs?: { prompt: string }) => {
    setPrompt({ type: '', prompt: '' })
    onCloseModal(closeArgs)
  }

  const onTransformContent = () => {
    return onClose(prompt)
  }

  useEffect(() => {
    setDisabled(prompt.type.length == 0 || prompt.prompt.length == 0)
  }, [prompt])

  return (
    <ThemeProvider theme={theme}>
      <Modal.Root open={isVisible}>
        <Modal.Content
          onEscapeKeyDown={() => onClose()}
          style={{ overflow: 'visible' }}
        >
          <Modal.Title>
            <span aria-label="Robot" role="img" style={{ marginRight: 8 }}>
              🤖
            </span>
            Transform Content
          </Modal.Title>
          <Modal.Body
            style={{
              overflowY: 'visible',
            }}
          >
            <Modal.Close onClick={() => onClose()} />
            <TransformContent inModal={true} onSetPrompt={setPrompt} />
          </Modal.Body>
          <Modal.Footer>
            <Button
              buttonText="Cancel"
              className="cancel-add"
              name="Cancel transformation"
              onClick={() => onClose()}
              variant="ghost"
            />
            <Button
              aria-disabled={disabled}
              buttonText="Transform Content"
              className="transform-content"
              disabled={disabled}
              name="Transform content"
              onClick={onTransformContent}
              variant="primary"
            />
          </Modal.Footer>
        </Modal.Content>
      </Modal.Root>
    </ThemeProvider>
  )
}
